// src/Hooks/useExportRequests.js
import { useMutation } from '@tanstack/react-query';
import api from '../lib/api';
import toast from 'react-hot-toast';

export const useExportRequests = () => {
    return useMutation({
        mutationFn: () =>
            api.get('/company/export/accepted-offers'),

        onSuccess: (response) => {

            const { download_url, filename } = response.data.data;

            if (!download_url) {
                toast.error('No download link received from server.');
                return;
            }

            const link = document.createElement('a');
            link.href = download_url;
            link.setAttribute('download', filename || 'accepted_offers_export.csv');
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toast.success('Export started! Download should begin shortly.');
        },

        onError: (error) => {
            console.error('Export failed:', error);
            toast.error(
                error.response?.data?.message ||
                'Failed to export requests. Please try again.'
            );
        },
    });
};